import Image, { StaticImageData } from 'next/image';

type props = {
  style?: object;
  src: string | StaticImageData;
  alt: string;
  width?: number;
  height?: number;
  fill?: boolean;
  className?: string;
  onClick?: () => void;
  onError?: (event: any) => void;
};

export const PEIImage = ({
  style,
  src,
  alt,
  width,
  height,
  fill,
  className,
  onClick,
  onError,
}: props) => {
  return (
    <Image
      style={style}
      src={src}
      alt={alt}
      width={width}
      height={height}
      fill={fill}
      className={className}
      onClick={onClick}
      onError={onError}
    />
  );
};
